import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { getTimezoneId } from 'utils/dateUtils'
import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'

import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from '../constants'
import { selectDateRange } from '../selectors'

import { resolvedIncidentWidgetRedux } from './redux'

const getResolvedIncidentsWidgetEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      resolvedIncidentWidgetRedux.INITIATE,
      DATE_FILTER_CHANGE,
      SCANBACK_CHANGE
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .switchMap(() => {
      const state = store.getState()
      const selectedCompany = selectCompanyFilter(state)

      const feDateRange = selectDateRange(state)

      const baseParams = {
        feDateRange,
        timezone: getTimezoneId(),
      }

      return api.dashboard
        .getResolvedIncidentsWidget(selectedCompany?.value, baseParams)
        .map((response) => resolvedIncidentWidgetRedux.onSuccess(response.response))
        .catch((error) =>
          Observable.of(epicsErrorHandler(resolvedIncidentWidgetRedux.onError, error))
        )
        .takeUntil(
          action$.ofType(resolvedIncidentWidgetRedux.CANCEL, resolvedIncidentWidgetRedux.ERROR)
        )
    })

export default combineEpics(getResolvedIncidentsWidgetEpic)
